import jQuery from 'jquery';

// Force scroll to top

if (location.hash) {
    window.scrollTo(0, 0);
    setTimeout(function () {
        window.scrollTo(0, 0);
    }, 1);
}

jQuery(function ($) {
    const $HTML = $('HTML');
    const $BODY = $('BODY');
    const scrollContainer = $('#root');
    let prevScrollpos = getScrollPosition();

    // Overlay

    function getScrollPosition() {
        return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    }

    function openOverlay() {
        const currentScrollPos = getScrollPosition();
        prevScrollpos = currentScrollPos;
        $HTML.addClass('overlay-open');
        scrollContainer.scrollTop(currentScrollPos);
    }

    function closeOverlay() {
        $HTML.removeClass('overlay-open');
        $(window).scrollTop(prevScrollpos);
    }

    $BODY.on('click.open-overlay', '.header__menu-toggle', (e) => {
        if (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey) {
            return;
        }
        e.preventDefault();
        openOverlay();
    });

    // Mainmenu hovers

    $('.header__mainmenu > LI > DIV').each((i, el) => {
        let timer = null;
        const trigger = $(el);
        console.log(trigger);
        const menu = trigger.next();
        trigger
            .on('mouseover.mainmenu', () => {
                clearTimeout(timer);
                trigger.closest('UL').find('.open').removeClass('open');
                trigger.addClass('open');
            })
            .on('mouseleave.mainmenu', () => {
                timer = setTimeout(() => {
                    trigger.removeClass('open');
                }, 250);
            });
        menu.on('mouseover.mainmenu', () => {
            clearTimeout(timer);
        }).on('mouseleave.mainmenu', () => {
            timer = setTimeout(() => {
                trigger.removeClass('open');
            }, 250);
        });
    });

    // Prepare mobile menu

    const contents = $('#primary-menu');
    const overlay = $('<div class="overlay"></div>');
    const overlay_anim = $('<div class="overlay__anim"></div>');
    const overlay_header = $('<div class="overlay__header"><a href="#" class="overlay__close">×</a></div>');
    const overlay_body = $('<div class="overlay__body"></div>');
    const overlay_inner = $('<div class="overlay__inner"></div>');

    overlay_header
        .find('A.overlay__close')
        .on('click', (ex) => {
            ex.preventDefault();
            closeOverlay();
        })
        .add(overlay);

    contents.clone().contents().appendTo(overlay_inner);

    overlay_header.appendTo(overlay_anim);
    overlay_inner.appendTo(overlay_body);
    overlay_body.appendTo(overlay_anim);
    overlay_anim.appendTo(overlay);
    overlay.appendTo('BODY');

    // Tabs

    $('.list-tabs[data-list]').each((index, tabs) => {
        const $list = $('#' + $(tabs).attr('data-list'));
        const $tabs = $(tabs);
        if ($list.length !== 1) {
            return;
        }
        $tabs.on('click.button', 'button:not(.active)', (tab) => {
            $tabs.find('.active').removeClass('active');
            const $tab = $(tab.currentTarget);
            $tab.addClass('active');
            const desiredKey = $tab.data('key');
            $list
                .find('LI')
                .removeClass('hidden')
                .filter((i, item) => {
                    if (desiredKey === '') {
                        return false;
                    }
                    return $(item).data('category') !== desiredKey;
                })
                .addClass('hidden');
        });
    });

    // Smooth scroll to anchor

    $('A[href^="#"]').each((index, anchor) => {
        const $anchor = $(anchor);
        $anchor.on('click', (e) => {
            e.preventDefault();
            document.querySelector($anchor.attr('href')).scrollIntoView({
                behavior: 'smooth',
            });
        });
    });

    // Owl
    $BODY.mousemove(function(event) {
        var eye = $('.owl__eye');
        var x = (eye.offset().left) + (eye.width() / 2);
        var y = (eye.offset().top) + (eye.height() / 2);
        var rad = Math.atan2(event.pageX - x, event.pageY - y);
        var rot = (rad * (180 / Math.PI) * -1) + 180;
        eye.css({
            '-webkit-transform': 'rotate(' + rot + 'deg)',
            '-moz-transform': 'rotate(' + rot + 'deg)',
            '-ms-transform': 'rotate(' + rot + 'deg)',
            'transform': 'rotate(' + rot + 'deg)'
        });
    });
});
